
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

interface AuthButtonsProps {
  className?: string;
}

const AuthButtons = ({ className = "" }: AuthButtonsProps) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  const isLoginPage = location.pathname === "/login";

  if (!user && !isLoginPage) {
    return (
      <Button
        onClick={() => navigate("/login")}
        className={className}
      >
        Sign In
      </Button>
    );
  }
  
  return null;
};

export default AuthButtons;

